export const handleAppRefresh = (shouldReloadApp) => {
  if (!shouldReloadApp) {
    return;
  }

  window.location.reload();
};
